
import Vue from 'vue'
import App from './App.vue'
import router from './router' // 确保导入路由实例
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 必须的样式文件

Vue.config.productionTip = false

Vue.use(ElementUI) // 关键注册语句

new Vue({
  router, // 必须注入路由实例
  render: h => h(App)
}).$mount('#app')


Vue.directive('no-space', {
  bind(el, binding, vnode) {
    const component = vnode.componentInstance;
    // 监听输入事件
    component.$on('input', (value) => {
      const newVal = value.replace(/\s/g, '');
      if(newVal != value)
      {
        component.$emit('input', newVal); // 更新值
      }
    });
  }
});